import clsx from 'clsx';
import { kebabCase } from 'lodash';
import React from 'react';

import { TextButton } from '@components/Button/variants';
import { topic_landing_path } from '@routes';
import { encodeEntity } from '@utils/formatting';

export default function TopicPill({
  topic,
  matchingEntity = false,
}: {
  topic: string;
  matchingEntity?: boolean;
}) {
  return (
    <TextButton
      as="link"
      size="small"
      className={clsx('track-click', { 'text-primary-magenta': matchingEntity })}
      href={topic_landing_path(encodeEntity(topic))}
      data-name={`topic badge: ${kebabCase(topic)}`}
      data-type="link"
    >
      {topic}
    </TextButton>
  );
}
